export const CustomerFeeSetupSteps = {
  SELECT_CUSTOMER: 'SELECT_CUSTOMER',
  SET_FEE: 'SET_FEE',
  SUCCESS: 'SUCCESS',
} as const

export type CustomerFeeSetupStep =
  (typeof CustomerFeeSetupSteps)[keyof typeof CustomerFeeSetupSteps]

export const CustomerFeeSetupTypes = {
  PAYINS: 'PAYINS',
  PAYOUTS: 'PAYOUTS',
} as const

export type CustomerFeeSetupType =
  (typeof CustomerFeeSetupTypes)[keyof typeof CustomerFeeSetupTypes]

export const FeeStructureTypes = {
  BLENDED: 'Blended',
  PERCENTAGE: 'Percentage',
  FIXED: 'Fixed',
} as const

export type FeeStructureType = (typeof FeeStructureTypes)[keyof typeof FeeStructureTypes]

export const feeStructureOptions = [
  { value: FeeStructureTypes.BLENDED, leftText: FeeStructureTypes.BLENDED },
  { value: FeeStructureTypes.PERCENTAGE, leftText: FeeStructureTypes.PERCENTAGE },
  { value: FeeStructureTypes.FIXED, leftText: FeeStructureTypes.FIXED },
]
